import PropTypes from "prop-types";
import React from "react";
import { connect } from "react-redux";
import { Button, Card, Container, Icon, Label, Popup } from "semantic-ui-react";
import FormatCurrency from "shared/components/currency/FormatCurrency";
import FormatQuantity from "shared/components/quantity/FormatQuantity";
import { FormattedMessage } from "react-intl";
import { getRequiredUpdates } from "shared/selectors/unit/subLineItemRules";
import "./productOptions.scss";
import OptionDetailsModal from "shared/components/configurator/OptionDetailsModal";
import ProductInfoItem from "../../../builder_portal/components/product/ProductInfoItem";
import ThumbnailGallery from "./productOptionCard/ThumbnailGallery";
import { getAccount } from "../../selectors";
import ProductLineLabel from "../elements/productLineLabel";

class ProductOption extends React.Component {
  static propTypes = {
    subLineItem: PropTypes.object,
    option: PropTypes.object,
    onSelectProduct: PropTypes.func,
    renderMissingMappingIcon: PropTypes.bool,
    renderMetaThumbs: PropTypes.bool
  };

  constructor(props) {
    super(props);

    this.state = {
      info: false,
      loading: false,
      image: null,
      disabled: false,
      showDetailsModal: false
    };
  }

  componentWillUnmount() {
    this.didUnmount = true;
  }

  render() {
    const {
      subLineItem,
      option,
      index,
      renderMissingMappingIcon,
      renderMetaThumbs = true,
      renderQuantityLabel = true
    } = this.props;
    const { status } = subLineItem;
    const hasCart = !status.selectable;
    const isSelected = option.isBuyerSelection;
    const isAcceptable = option.isAcceptableProduct;
    const classes = ["product"];
    const showMissingMappingHint =
      renderMissingMappingIcon && !option.hasConfiguratorMapping;
    const showPriceTag = option.isActualSelection || status.selectable;

    if (this.renderStandardFlag) {
      classes.push("standard");
    }

    let icon;
    let color;
    let buttonLabel;
    let buttonClass;

    if (hasCart) {
      classes.push("hasCart");

      if (isSelected) {
        classes.push("selected");
        icon = "hourglass two";
        buttonLabel = (
          <FormattedMessage
            defaultText="buyerPortal.status.selected"
            id="buyerPortal.status.selected"
          />
        );
      } else {
        icon = "lock";
        buttonLabel = (
          <FormattedMessage
            defaultText="buyerPortal.status.notSelected"
            id="buyerPortal.status.notSelected"
          />
        );
      }
      if (status && option.isSelected) {
        classes.push("selected");
        icon = "check";
        color = status.color;
        buttonLabel = <span>{status.label}</span>;
      } else {
        classes.push("discarded");
      }
    } else if (isSelected) {
      classes.push("selected");
      icon = "check";
      buttonLabel = (
        <FormattedMessage
          defaultText="buyerPortal.actions.selectedProduct"
          id="buyerPortal.actions.selectedProduct"
        />
      );
    } else {
      icon = "heart outline";
      buttonLabel = (
        <FormattedMessage
          defaultText="buyerPortal.actions.selectProduct"
          id="buyerPortal.actions.selectProduct"
        />
      );
    }

    if ((isSelected && !isAcceptable) || !option.isValidSelection) {
      classes.push("incompatible");
      buttonClass = "warning";
      icon = "exclamation triangle";
      buttonLabel = "Ungültige Auswahl";
    }

    return (
      <Card
        key={option.id}
        className={`${classes.join(" ")}`}
        data-index={index}
        data-model="product"
        data-test="product"
        data-component="product"
        onClick={() => {
          if (!hasCart) this.handleSelection();
        }}
      >
        <div className="productImage">
          {this.renderImage(option.thumbUrl)}
          {renderQuantityLabel &&
            !option.isQuantityOnRequest &&
            this.renderQuantityLabel(subLineItem, option)}
          {showPriceTag && this.renderPriceTag(option)}
          {showMissingMappingHint && (
            <Icon name="eye" className="slash missing-mapping" color="orange" />
          )}
          {showPriceTag && this.renderExtraPrice()}
          {this.renderStandardFlag(option)}
        </div>
        <Card.Content
          className="description-wrapper"
          onClick={this.handleToggleInfoFn(option)}
        >
          {this.renderProductDetails(option)}
          <Icon circular name="info" className="clickable" />
          <OptionDetailsModal
            open={this.state.info}
            onClose={() => {
              this.setState({ info: false });
            }}
            onOpen={() => {
              this.setState({ info: true });
            }}
            option={option}
            subLineItem={subLineItem}
          />
        </Card.Content>
        {renderMetaThumbs && this.renderMetaThumbs(option)}
        {this.renderButton(buttonClass, buttonLabel, icon, color)}
      </Card>
    );
  }

  renderWithMissingMappingHint(component) {
    const { renderMissingMappingIcon, option } = this.props;
    const showMissingMappingHint =
      renderMissingMappingIcon && !option.hasConfiguratorMapping;

    return (
      <Popup
        position="top center"
        // positionFixed
        disabled={!showMissingMappingHint}
        trigger={component}
      >
        <FormattedMessage id="configurator.missingMapping" />
      </Popup>
    );
  }

  renderQuantityLabel(subLineItem, option) {
    if (option.priceStrategy !== "flat") {
      return (
        <Label
          className="quantity-label"
          data-price-strategy={option.priceStrategy}
          data-attr="quantity"
        >
          <FormatQuantity
            value={subLineItem.quantity}
            unit={option.priceStrategy}
          />
        </Label>
      );
    }
  }

  renderExtraPrice() {
    const {
      requiredUpdates: { extraCosts, extraCostsOnRequest }
    } = this.props;

    if (!extraCostsOnRequest && extraCosts) {
      return (
        <Label className="extra-price-tag" data-attr="extraCosts">
          <Icon name="linkify" />
          {extraCosts > 0 ? "Mehrkosten: +" : "Minderkosten: "}
          <FormatCurrency amount={extraCosts} />
        </Label>
      );
    }
  }

  renderPriceTag(option) {
    const { priceField, subLineItem } = this.props;

    if (option.isOnRequest) {
      return (
        <Label className="on-request-tag" data-attr="total">
          Preis auf Anfrage
        </Label>
      );
    }
    if (option.isQuantityOnRequest && option.total != 0) {
      const field = subLineItem.isOptional ? "price" : "relativePrice";
      return (
        <Label className="on-request-tag" data-attr="total">
          Preis auf Anfrage (+
          <FormatCurrency
            amount={option[field]}
            priceStrategy={option.priceStrategy}
          />
          )
        </Label>
      );
    }
    const amount = option[priceField || "relativeTotal"];
    const displayAmount = amount >= 0 ? amount : -amount;
    const displayIcon = amount >= 0 ? "plus" : "minus";
    return (
      <Label
        className="price-tag"
        data-attr="total"
        data-price-strategy={option.priceStrategy}
      >
        <Icon name={displayIcon} />
        <FormatCurrency amount={displayAmount} />
      </Label>
    );
  }

  renderStandardFlag(option) {
    if (option.isDefault) {
      return (
        <Label basic attached="bottom left" className="standard-flag">
          <span>Standardauswahl</span>
        </Label>
      );
    }
  }

  renderProductDetails(option, renderTags = true) {
    const tags = option.productLines.map(tag => (
      <ProductLineLabel
        key={`${option.id}-${tag.composite_id}`}
        productLine={tag}
      />
    ));

    const productDetails = (
      <Container
        onClick={this.handleToggleInfoFn(option)}
        className="meta title clickable"
      >
        <ProductInfoItem product={option} mode="bp_card" />
        {!!tags.length && renderTags && (
          <div
            style={{ marginTop: "10px" }}
            data-component="product-tags"
            data-test="product-tags"
          >
            {tags}
          </div>
        )}
      </Container>
    );

    return this.renderWithMissingMappingHint(productDetails);
  }

  renderImage(url) {
    return (
      <div
        className="canvas"
        style={{ backgroundImage: `url(${this.state.image || url})` }}
      />
    );
  }

  renderMetaThumbs(option) {
    return (
      <Card.Content className="thumbnail-wrapper">
        <ThumbnailGallery option={option} />
      </Card.Content>
    );
  }

  renderButton(buttonClass, buttonLabel, icon) {
    const { subLineItem, option } = this.props;
    const isSelected = option.isBuyerSelection;
    const isAcceptable = option.isAcceptableProduct;
    const { status } = subLineItem;

    if (isSelected || isAcceptable) {
      const button = (
        <Button
          loading={this.state.loading || this.props.loading}
          disabled={!option.isActualSelection && !status.selectable}
          content={buttonLabel}
          icon={icon}
          fluid
          className={`select-product ${buttonClass ?? ""}`}
        />
      );
      return this.renderWithMissingMappingHint(button);
    }
    return null;
  }

  handleToggleInfoFn() {
    return event => {
      event.stopPropagation();

      return this.handleToggleInfo();
    };
  }

  handleToggleInfo = () => {
    if (this.state.info) {
      this.setState({ info: false });
    } else {
      this.setState({ info: true });
    }
  };

  handleSelection = () => {
    const { handleSelectFn, option } = this.props;
    const isSelected = option.isBuyerSelection;
    const isAcceptable = option.isAcceptableProduct;

    if (isSelected || isAcceptable) {
      this.setState({ loading: true });

      const closeFn = () => {
        if (!this.didUnmount) {
          this.setState({ loading: false });
        }
      };

      return handleSelectFn(option).then(closeFn);
    }
  };
}

const mapStateToProps = (state, props) => {
  const { subLineItem, option } = props;
  const optionWithVideo = option;
  if (getAccount(state).isEnabled("supplier_integration")) {
    // Mock images (related: YoutubeVideoHack)
    if ([46, 30864].includes(option.id)) {
      optionWithVideo.images.push({
        service: "youtube",
        id: "braH1VUDtg8",
        src: "https://www.youtube.com/watch?v=braH1VUDtg8"
      });
    }
  }
  const requiredUpdates = getRequiredUpdates(state)(subLineItem.id, option.id);

  return {
    requiredUpdates,
    option: optionWithVideo
  };
};

export default connect(mapStateToProps)(ProductOption);
